module.exports = __webpack_public_path__ + "img/belgium.12d689e5.svg";